module.exports = __webpack_public_path__ + "img/100_dice[8].07ac2612.png";